'use client';

import { Home } from "lucide-react";
import { motion } from "framer-motion";
import { useRouter, usePathname } from "next/navigation";
import Image from "next/image";

const NotFound = () => {
    const router = useRouter();
    const pathname = usePathname();
    
    const handleHomeClick = () => {
        // Check if current path includes v2
        if (pathname?.includes('/v2')) {
            router.push('/v2');
        } else {
            router.push('/');
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted flex items-center justify-center p-4">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="text-center space-y-8"
            >
                <Image
                    src="/logos/umynd.icon.black.svg"
                    alt="Umynd Icon"
                    width={256}
                    height={256}
                    className="mx-auto h-56 w-auto text-black sm:h-64 dark:text-gray-100"
                />

                <div className="space-y-6">
                    <motion.h1
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                        className="text-4xl sm:text-5xl font-bold text-[#4C4C47]"
                    >
                        Oops! Page Not Found
                    </motion.h1>

                    <motion.p
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.3 }}
                        className="text-lg max-w-md mx-auto text-[#4C4C47]/80"
                    >
                        We couldn&apos;t find the page you&apos;re looking for. Let&apos;s get you back on track.
                    </motion.p>

                    <motion.button
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.4 }}
                        className="px-8 py-3 bg-[#446CC0] text-white rounded-[26px] relative group hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                        onClick={handleHomeClick}
                    >
                        <span className="relative flex items-center gap-2 font-medium">
                            <Home className="w-5 h-5" />
                            Back to Home
                        </span>
                    </motion.button>
                </div>
            </motion.div>
        </div>
    );
};

export default NotFound;